@if (imageId()) {
  <div class="journey-image">
    <ui-api-image
      [imageId]="imageId()"
      [styles]="{ 'max-width': '64px' }"
    ></ui-api-image>
  </div>
}
